import React, { Component } from "react";
import { Link } from "react-router-dom";
// get our fontawesome imports
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class Header extends Component {
  constructor() {
    super();
    this.state = {
      msg: null,
      type: null,
      flash: false,
      alert: null,
    };
  }

  render() {
    return (
      <nav
        className="navbar navbar-expand-lg navbar-light fixed-top bg-transparent pt-4 trans-all"
        id="myNav"
      >
        <div className="container d-flex justify-content-between">
          <Link className="navbar-brand" to="/">
            <img
              src="/img/creatifa-logo-with-text.png"
              height="30"
              className="d-inline-block align-top"
              alt=""
            />
          </Link>

          <button className="btn d-lg-none d-flex text-danger border-danger">
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>
      </nav>
    );
  }
}

export default Header;
